import { FileUploadStatusWrapperType } from './FileUploadStatusWrapper.props';

/**
 * Format file size in bytes to human readable format
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + sizes[i];
};

/**
 * Calculate time ago from a given date
 */
export const getTimeAgo = (date: Date): string => {
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) {
    return `${diffInSeconds} sec ago`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes} min ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours} hr ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
};

/**
 * Extract file extension from filename
 */
export const getFileExtension = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1 || lastDotIndex === 0) return '';
  const extension = filename.slice(lastDotIndex + 1).toUpperCase();
  return extension.length > 4 ? extension.substring(0, 3) : extension;
};

/**
 * Get status label based on upload status
 */
export const getStatusLabel = (
  status: FileUploadStatusWrapperType,
  fileSize: string,
  processedAt?: Date
): string => {
  switch (status) {
    case 'pending':
      return `Selected | ${fileSize}`;
    case 'storing':
      return 'Preparing for upload...';
    case 'stored':
      return `Ready for upload | ${fileSize}`;
    case 'uploading':
      return 'Uploading...';
    case 'processing':
      return 'Processing...';
    case 'uploaded':
      return `Uploaded & Processed ${processedAt ? getTimeAgo(processedAt) : 'Just now'} | ${fileSize}`;
    case 'failed':
    case 'error-processing':
    case 'size-too-large':
    case 'type-not-allowed':
    case 'batch-size-exceeded':
    case 'file-count-exceeded':
    case 'storage-failed':
      return fileSize;
    default:
      return status;
  }
};
